import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { translateOptionSymbol } from '../../../../../../../../stores/websocketStore/utils/mungingUtils/translateOptionSymbol';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { buildMarketDataKeys } from '../../../../../../../../stores/websocketStore/utils/marketDataRouting';
import ApplyRounding from '../../../../../../../../utils/math/ApplyRounding';
import { resolveMarketDataBrokerage } from '../../../../../../../../utils/accountRouting';
import { Body3 } from '../../../../../../../atomic/text/Text';
import style from './OptionConfigurationPanel.module.css';
const headerList = ['Symbol', 'Bid', 'Ask', 'Spread %'];
export const OptionConfigurationPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { watchlistStore, priceDataStore, tradePlanStore, accountBalanceStore } =
      useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const dataSource = tradePlan.dataSource;
    const accounts =
      Object.keys(accountBalanceStore.balances).map((accountNumber) => {
        const balance = accountBalanceStore.balances[accountNumber];
        return {
          accountNumber,
          brokerage: balance?.brokerage,
        };
      }) ?? [];
    const brokerage = resolveMarketDataBrokerage({
      accountNumber: tradePlan.accountNumber,
      accounts,
      currentBrokerage: tradePlan.brokerage,
      dataSource,
    });
    const hash = `__tradePlan${tradePlanId}`;
    const symbols = watchlistStore.watchlists[hash] ?? [];
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table style={{ color: colors.lightGrey }} className={style.table}>
            <thead>
              <tr>
                {headerList.map((column) => (
                  <th key={column}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {column}
                    </Body3>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {symbols.length < 2 ? (
                <tr>
                  <td>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      No options pass configuration.
                    </Body3>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                symbols.map(({ symbol }) => {
                  if (symbol.length < 6) return null;
                  const hash = buildMarketDataKeys({
                    symbol,
                    dataSource,
                    brokerage,
                  }).find((key) => priceDataStore.lastQuote[key]);
                  const bid = (hash && priceDataStore.lastQuote[hash]?.bid) ?? '-';
                  const ask = (hash && priceDataStore.lastQuote[hash]?.ask) ?? '-';
                  const spread = ask - bid;
                  const spreadPct = ApplyRounding(
                    (spread / ((bid + ask) / 2)) * 100,
                    2
                  );
                  return (
                    <tr key={symbol}>
                      <td>
                        <Body3 fontWeight={700} color={colors.lightGrey}>
                          {translateOptionSymbol(symbol)}
                        </Body3>
                      </td>
                      <td>
                        <Body3 fontWeight={700} color={colors.lightGrey}>
                          {ApplyRounding(bid, 2)}
                        </Body3>
                      </td>
                      <td>
                        <Body3 fontWeight={700} color={colors.lightGrey}>
                          {ApplyRounding(ask, 2)}
                        </Body3>
                      </td>
                      <td>
                        <Body3 fontWeight={700} color={colors.lightGrey}>
                          {spreadPct}%
                        </Body3>
                      </td>
                    </tr>
                  );
                })
              )}

            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

OptionConfigurationPanel.tabsRole = 'TabPanel';
